import * as React from 'react';

import {GridList} from 'shells/grid-list/grid-list';

import type {LandingPageStubFragment} from 'nutshell-graphql-types';

import {EmptyState} from './empty-state';
import {LandingPageCard} from './page-card/landing-page-card';

const CARD_WIDTH = 300;
const CARD_HEIGHT = 300;

type Props = {
    landingPages: LandingPageStubFragment[];
    isLoading: boolean;
    error: string | null | undefined;
    archived: boolean;
};

export function LandingPagesBoard(props: Props) {
    return (
        <div>
            <GridList
                itemWidth={CARD_WIDTH}
                loadingState={{itemHeight: CARD_HEIGHT, itemBackgroundColor: 'white'}}
                isLoading={props.isLoading}
                error={props.error}
                emptyStateComponent={<EmptyState />}
                isFiltering={props.archived}
                nothingFoundState={{
                    title: 'No archived pages were found',
                    subtitle: 'Your archived pages will appear here.',
                }}
            >
                {props.landingPages.map((page) => (
                    <LandingPageCard key={page.id} page={page} isArchived={props.archived} />
                ))}
            </GridList>
        </div>
    );
}
